var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "vehicle_list" },
    _vm._l(_vm.vehicleOwnershipList, function (item, index) {
      return _c("div", { key: index, staticClass: "car_item" }, [
        _c("p", { staticClass: "car_info" }, [
          _vm._v("品牌：" + _vm._s(item.brandName)),
        ]),
        _c("p", { staticClass: "car_info" }, [
          _vm._v("品系：" + _vm._s(item.strainName)),
        ]),
        _c("p", { staticClass: "car_info" }, [
          _vm._v(
            "最新购车时间：" +
              _vm._s(_vm._f("formatShortDate")(item.purchaseDate))
          ),
        ]),
        _c("p", { staticClass: "car_info" }, [
          _vm._v("底盘号：" + _vm._s(item.batholithNo)),
        ]),
        _c("p", { staticClass: "car_info" }, [
          _vm._v(
            "满意点：" +
              _vm._s(
                item.satisfiedContentName ? item.satisfiedContentName : "暂无"
              )
          ),
        ]),
        _c("p", { staticClass: "car_info" }, [
          _vm._v(
            "不满意点：" +
              _vm._s(
                item.unsatisfiedContentName
                  ? item.unsatisfiedContentName
                  : "暂无"
              )
          ),
        ]),
      ])
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }